import { combineReducers } from 'redux';
import workstationReducer from 'features/workstationSlice';
import itemReducer from 'features/itemSlice';
import { itemsSearchService } from 'app/services/itemsSearchService/itemsSearchService';
import { taxRulesService } from 'app/services/taxRulesService/taxRulesService';
import { ecoTaxService } from 'app/services/ecoTaxService/ecoTaxService';
import { fmsrService } from 'app/services/fmsrService/fmsrService';

export const reducer = combineReducers({
  [itemsSearchService.reducerPath]: itemsSearchService.reducer,
  [taxRulesService.reducerPath]: taxRulesService.reducer,
  [ecoTaxService.reducerPath]: ecoTaxService.reducer,
  [fmsrService.reducerPath]: fmsrService.reducer,
  workstation: workstationReducer,
  item: itemReducer,
});
